module.exports = __webpack_public_path__ + "img/video-preview.8cdac0f7.png";